/* eslint-disable */

import { gql } from '@apollo/client';
import clientApollo from './clientApollo';

type Global = {
  label: string;
  package: string;
  type: string;
  value: string;
};

type GlobalsResponse = {
  intellisenseCompletions: Global[];
};

const intellisense = {
  fetch: async (realm: string, projectId: string | null) => {
    const { data } = await clientApollo.query<GlobalsResponse>({
      query: gql`
        query intellisenseCompletions($realm: String!, $projectId: String) {
          intellisenseCompletions(realm: $realm, projectId: $projectId) {
            type
            label
            value
            package
          }
        }
      `,
      variables: { realm, projectId }
    });

    return data.intellisenseCompletions;
  }
};

export default intellisense;
